import { createContext, useContext, useEffect, useState } from "react";
import en from "./en";
import am from "./am";
import om from "./om";
import ti from "./ti";
import { useSettings } from "../lib/providers";

export const dicts = { en, am, om, ti };
export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "am", label: "አማርኛ", short: "AM" },
  { code: "om", label: "Afaan Oromoo", short: "OM" },
  { code: "ti", label: "ትግርኛ", short: "TI" },
];

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hh_lang") || "en");
  useEffect(() => {
    localStorage.setItem("hh_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const { settings } = useSettings();
  const overrides = settings?.content?.[lang] || {};
  const t = (key, vars) => {
    let s = overrides[key] || (dicts[lang][key] ?? en[key] ?? key);
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replace(`{${k}}`, v); });
    return s;
  };
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
